module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "old_progress"
  }, [_c('span', {
    staticClass: "old_progress_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "old_progress_all"
  }, [_vm._v("排产量"), _c('span', {
    staticClass: "old_progress_all_num"
  }, [_vm._v(_vm._s(_vm.allNum) + "吨")])])]), _vm._v(" "), _c('div', {
    staticClass: "new_progress"
  }, [_c('span', {
    staticClass: "new_progress_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "new_progress_all",
    style: ({
      width: _vm.numWidth
    })
  }, [_vm._v("完成量"), _c('span', {
    staticClass: "new_progress_all_num"
  }, [_vm._v(_vm._s(_vm.overNum) + "吨")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dd90f5f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progressCard.vue
// module id = 911
// module chunks = 1